import { Foundation, idempotentFoundationInit } from 'frontend/common-imports'
import { Accordion } from 'foundation-sites/js/foundation.accordion';
globalThis.skipFoundation = true
Foundation.plugin(Accordion, 'Accordion');
idempotentFoundationInit()
